module.exports = __webpack_public_path__ + "static/media/image-8.a17b5dd0.avif";